/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_No_Spaces_Found_DescriptionInputs */



/**
* | output |
* | --- |
* | "Try adjusting your search criteria" |
*
* @param {Spaces_No_Spaces_Found_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_no_spaces_found_description = /** @type {((inputs?: Spaces_No_Spaces_Found_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_No_Spaces_Found_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Versuche, deine Suchkriterien anzupassen")
	return /** @type {LocalizedString} */ ("Try adjusting your search criteria")
});